/**
 * Source-controlled operational switch for the Market Research Brand-name J&A
 * workflow. Keep this setting aligned with the backend policy module.
 *
 * Changing this value requires rebuilding/redeploying the UI. Environment
 * variables deliberately have no effect.
 */
export const MARKET_RESEARCH_BRAND_NAME_JA_ENABLED = true;

export function isMarketResearchBrandNameJaEnabled(): boolean {
  return MARKET_RESEARCH_BRAND_NAME_JA_ENABLED;
}
